import { doc, getDoc } from 'firebase/firestore';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkCreator } from '../../../index';
import { STATISTICS_REDUCER_NAME } from '../types';
import { COLLECTION } from '../../../../firestore/collectionNames';
import { firestoreDateMapper } from '../../../../helpers/firestoreDateMapper';
import { CreatorStatsDocument } from '../../../../models/documents/Reports';

export const fetchCreatorStats = createAsyncThunk<
  CreatorStatsDocument | null,
  void,
  AsyncThunkCreator<number>
>(
  `${STATISTICS_REDUCER_NAME}/fetchCreatorStats`,
  async (_, { rejectWithValue, extra: { auth, db } }) => {
    try {
      const user = auth().currentUser;
      if (!user) {
        throw new Error('user-is-not-logged');
      }
      const ref = doc(db, COLLECTION.REPORTS, user.uid);

      const docSnap = await getDoc(ref);

      return docSnap.exists() ? firestoreDateMapper<CreatorStatsDocument>(docSnap) : null;
    } catch (e) {
      const error = e as any;

      return rejectWithValue(error.message);
    }
  }
);
